import { render, staticRenderFns } from "./nameManagement.vue?vue&type=template&id=54f91868&scoped=true"
import script from "./nameManagement.vue?vue&type=script&lang=js"
export * from "./nameManagement.vue?vue&type=script&lang=js"
import style0 from "./nameManagement.vue?vue&type=style&index=0&id=54f91868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f91868",
  null
  
)

export default component.exports